import React from "react"

const Introduction = () => {
  return (
    <React.Fragment>
      <div className="container container-text my-5">
        <h2 className="display-4 brand text-center">
          Selamat Datang di Vivaldy Skin Clinic
        </h2>
        <p className="text-lead text-center brand-paragraph">
          Kita semua terlahir dengan kulit yang indah. Inilah tempat dimana kamu
          bisa merawat kulitmu dan juga menjaganya dari penyakit maupun faktor
          lingkungan.Inilah saatnya untuk merawat kulitmu.
        </p>
      </div>
    </React.Fragment>
  )
}

export default Introduction
